import { render, staticRenderFns } from "./PriceTrendModal.vue?vue&type=template&id=09d1919c&scoped=true"
import script from "./PriceTrendModal.vue?vue&type=script&lang=ts"
export * from "./PriceTrendModal.vue?vue&type=script&lang=ts"
import style0 from "./PriceTrendModal.vue?vue&type=style&index=0&id=09d1919c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09d1919c",
  null
  
)

export default component.exports